<template>
  <div id="inventoryIndex" class="aside-menu-to-content">
    <div class="secondary-menu-container">
      <div class="secondary-menu-title">库存</div>
      <second-menu :secondaryMenuMap="secondaryMenuMap"></second-menu>
    </div>
    <div class="content-container">
      <!-- 二级菜单渲染入口 -->
      <router-view></router-view>
    </div>
  </div>
</template>

<script >
// 页面二级菜单
import SecondMenu from 'components/layout/SecondMenu';

export default {
  data() {
    return {
      secondaryMenuMap: [
        {
          menuName: '商品库存',
          url: '/admin/inventory/goods-inventory',
          keyword: 'ROLE_STORAGE_goods_search',
          childrenMenu: []
        },
        {
          menuName: '库存编辑',
          url: '/admin/inventory/goods-edit',
          keyword: 'ROLE_STORAGE_goods_search',
          childrenMenu: []
        },
        {
          menuName: '商品入库',
          url: '/admin/inventory/storage',
          keyword: 'ROLE_STORAGE_order_search',
          childrenMenu: []
        },
        {
          menuName: '商品出库',
          url: '/admin/inventory/outStorage',
          keyword: 'ROLE_STORAGE_order_search',
          childrenMenu: []
        },
        {
          menuName: '仓库管理',
          url: '/admin/inventory/warehouse-setting',
          keyword: 'ROLE_STORAGE_store_manage',
          childrenMenu: []
        }
      ]
    };
  },
  methods: {
    onMenuConfirm(url) {
      // 路由跳转
      console.log('路由--', url);
      this.$router.push({
        path: url
      });
    }
  },
  components: {
    SecondMenu
  }
};
</script>

<style lang="scss" scoped>
@import "common/styles/aside-menu-to-content.scss";
</style>
